import React from 'react';
import { Button, icons } from '@applyboard/ui-components';
import ABLink from "../../../components/Link";
var Plus = icons.Plus;
function AddApplicationButton() {
  return /*#__PURE__*/React.createElement(Button, {
    mb: [2, 0],
    startIcon: /*#__PURE__*/React.createElement(Plus, null),
    to: "/search",
    "aria-label": "Add Application",
    component: ABLink
  }, "Add Application");
}
export default /*#__PURE__*/React.memo(AddApplicationButton);